var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"secondary"}}),_c('div',{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.loadingText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }